export enum EmailType {
	REMIND_NOT_PLAYED_TICKET = 'remind_not_played_ticket',
	WIN = 'win',
	LOSE = 'lose',
	CANCEL = 'cancel',
	BANK = 'bank',
	REMIND_PAY_DATE = 'remind_paydate',
	PAYMENT = 'payment',
	CONSENT = 'consent',
}
